// extracted by mini-css-extract-plugin
export default {"contents":"uF-z","sectionHeading":"vF-z"};